<script lang="ts" setup>
import type { Editor } from '@tiptap/vue-3'
import type { StyleValue } from 'vue'
import { computed } from 'vue'
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from '@/foundation/dropdown-menu'
import ActionDropdownButton from '@/notebook/components/ActionDropdownButton.vue'
import type { ButtonViewReturnComponentProps } from '@/notebook/type'
import { getShortcutKey } from '@/notebook/utils/plateform'

export type Item = {
  title: string
  icon?: any
  level?: number
  isActive: NonNullable<ButtonViewReturnComponentProps['isActive']>
  action?: ButtonViewReturnComponentProps['action']
  style?: StyleValue
  shortcutKeys?: string[]
  disabled?: boolean
  divider?: boolean
  default?: boolean
}
type Props = {
  editor: Editor
  disabled?: boolean
  color?: string
  shortcutKeys?: string[]
  maxHeight?: string | number
  tooltip?: string
  items?: Item[]
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  color: undefined,
  maxHeight: undefined,
  tooltip: '',
  shortcutKeys: undefined,
  items: () => [],
})

const active = computed(() => {
  const find: any = props.items.find((k: any) => k.isActive())

  if (find && !find.default) {
    return {
      ...find,
    }
  }
  const item: Item = {
    title: props.tooltip,
    level: 0,
    isActive: () => false,
  }

  return item
})
</script>

<template>
  <ActionDropdownButton :disabled="disabled" :tooltip="tooltip" :title="active?.title" btn_class="min-w-24 max-w-32">
    <template v-for="(item, index) in props.items" :key="index">
      <DropdownMenuCheckboxItem :checked="active.title === item.title" @click="item.action">
        <div class="ml-1 h-full" :class="`heading-` + item.level">
          {{ item.title }}
        </div>
        <DropdownMenuShortcut class="pl-4">{{
          item.shortcutKeys?.map((item) => getShortcutKey(item)).join(' ')
        }}</DropdownMenuShortcut>
      </DropdownMenuCheckboxItem>
      <DropdownMenuSeparator v-if="item.level === 0" />
    </template>
  </ActionDropdownButton>
</template>
